import React, { useEffect, useState } from 'react';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { fetchMerchantSites } from '../../store/merchnts/actions/sites';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../login/Login';
import { ISitesProps } from '../merchants/details/MerchantSitesPage';
import { SiteDetailsLayout } from '../../components/developers/sites/SiteDetailsLayout';
import { SiteInformation } from '../../components/developers/sites/SiteInformation';
import { Spinner } from '../../components/Spinner';
import './SiteDetails.scss';
import { fetchWidgetConfigurationData } from '../../store/merchnts/actions/widget';

interface Props {
	children?: React.ReactElement;
	isInfo?: boolean;
}

export const SiteDetails = ({ children, isInfo }: Props): React.ReactElement => {
	const { t } = useTranslation();
	const { id } = useParams<{ id: string }>();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const [siteData, setSiteData] = useState<ISitesProps>();
	const [loading, setLoading] = useState<boolean>(false);
	const user = parseJwt(authUser.idToken);
	const mid = user?.['custom:mid'];
	const { merchantState: { sitesList }, dispatch } = useMerchants();

	useEffect(() => {
		setLoading(true);
		if (sitesList.length) {
			const site = sitesList?.find(site => site?.id === id);
			setSiteData(site);
			void fetchWidgetConfigurationData(dispatch, site.id, mid);
			setLoading(false);
		}
		else {
			void fetchMerchantSites(dispatch, mid);
		}
	}, [sitesList]);

	const getPageRoute = (): JSX.Element => {
		if (siteData && isInfo) {
			return <SiteInformation siteInfo={siteData} />;
		} else if (siteData) {
			return (
				<>
					{children}
				</>
			);
		}
		return <></>;
	};

	const getPageLoader = (): JSX.Element => (
		<div className="card site-loading-height">
			<div className="card-body">
				<Spinner pageLoader/>
			</div>
		</div>
	);

	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: t('MENU.SITES'),
						path: '/developers/sites',
						isSeparator: false,
						isActive: false
					},
					{
						title: '',
						path: '',
						isSeparator: true,
						isActive: false
					}
				]}
			>
				{id}
			</PageTitle>

			<SiteDetailsLayout siteName={siteData?.name}>
				<>
					{
						loading
							? getPageLoader()
							: getPageRoute()
					}
				</>
			</SiteDetailsLayout>
		</>
	);
};
